// src/services/CountryService.js
import api from "./api";

export function getQuestions(page = 1, limit = 5) {
    return api.get(
        `/question/quiz?page=${page}&limit=${limit}`
    );
}

export function submitQuiz(data) {
    return api.post(`/question/submitquiz`, data);
}